import type { ReactNode } from 'react'
import React from 'react'

import * as S from './BottomContent.styled'

type BottomContentProps = {
  children: ReactNode
  actions?: ReactNode
}

export const BottomContent = ({ children, actions }: BottomContentProps) => {
  if (!children && !actions) return null

  return (
    <S.Container>
      {!!children && <S.LeftSide>{children}</S.LeftSide>}
      {!!actions && <S.RightSide>{actions}</S.RightSide>}
    </S.Container>
  )
}
